import { FormElements } from "lib/api/types";
import React from "react";

import ElementWrapped from "./ElementWrapped";

interface Props {
	group: number[];
	elements: FormElements;
	traversal: string[];
	fullWidth: boolean;
	fid: string;
}

const ELEMENTS_NO_PROPORTIONAL = ["date"];

const GroupItem = ({ group, elements, traversal, fullWidth, fid }: Props) => {
	return (
		<div
			style={{
				display: "flex",
				flexFlow: "row wrap",
			}}>
			{group.map((index: number) => {
				const elementLayout = elements[index]?.elementLayout;
				const uuid = traversal[index];
				const elem = elements[index]?.elem;

				const flexBasis = ELEMENTS_NO_PROPORTIONAL.includes(elem)
					? ""
					: `${elementLayout?.proportionalWidth || 100}%`;

				return (
					<ElementWrapped
						uuid={uuid}
						flexBasis={flexBasis}
						fullWidth={fullWidth}
						fid={fid}
						key={uuid}
					/>
				);
			})}
		</div>
	);
};

export default GroupItem;
